const tagTypeEnum = Object.freeze({
  ALLERGEN: 'A',
  DIET: 'D',
});

export default tagTypeEnum;
